export default __webpack_public_path__ + "fonts/kingvisioin_title.f417b33314649f0d1a241b662ec4093d.png";